import translate from '@i18n'
import { RecentMatchOutcome } from '@hooks/useRecentMatchOutcomes'

const getOutcomeTypeText = (type: RecentMatchOutcome['type']) => {
  return translate(`recentMatchOutcomes.type.${type}`).charAt(0)
}

export { getOutcomeTypeText }
